import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext';

interface RequireAuthProps {
  children: React.ReactNode;
  requiredRole?: string;
}

function RequireAuth({ children, requiredRole }: RequireAuthProps) {
  const { token, role } = useAuth();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default RequireAuth;
